import { render, staticRenderFns } from "./integrations-ring-group-availability.vue?vue&type=template&id=3861d8e5"
import script from "./integrations-ring-group-availability.vue?vue&type=script&lang=js"
export * from "./integrations-ring-group-availability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports